const ROLE_URLS = {
  INSERT: "/role/insert",
  GET_ALL: "/role/get_all",
  UPDATE: "/role/update",
  GET_ONE: "/role/get_one",
  DELETE: "/role/delete_one",
  GET_ALL_SELECT: "/role/get_all_select",
};

const USER_URLS = {
  INSERT: "/user/insert",
  GET_ALL: "/user/get_all",
  UPDATE: "/user/update",
  GET_ONE: "/user/get_one",
  DELETE: "/user/delete_one",
  GET_ALL_SELECT: "/user/get_all_select",
  ADMIN_RESET: "/user/admin_reset",
};
const STATE_URLS = {
  INSERT: "/state_db/insert",
  GET_ALL: "/state_db/get_all",
  UPDATE: "/state_db/update",
  GET_ONE: "/state_db/get_one",
  DELETE: "/state_db/delete_one",
  GET_ALL_SELECT_STATES: "/state_db/get_all_select",
};
const PASS_URL = {
  CHANGE_PASSWORD: "/user/user_reset",
};
const MODULES_URLS = {
  INSERT: "/admin_modules/insert_module_permission",
  GET_ALL: "/admin_modules/get_all",
  GET_ONE: "/admin_modules/get_one",
  DELETE: "/admin_modules/delete_one",
  STATUS_UPDATE: "/admin_modules/status_update",
  UPDATE: "/admin_modules/insert_role_permission",
  GET_ALL_ROLE: "/admin_modules/get_all_role_permission",
  ACTIONS_ROLE: "/admin_modules/insert_module_permission",
};
const EMAIL_SETTINGS_URLS = {
  GET_ALL: "/admin_mail/get_all",
  INSERT: "/admin_mail/insert",
  GET_ONE: "/admin_mail/get_one",
  DELETE: "/admin_mail/delete_one",
  UPDATE: "/admin_mail/update",
};
const SETTINGS_URL = {
  INSERT: "/site/insert",
  GET_ALL: "/site/get_all",
  // GET_ALL_SELECT_TYPES: "/site/get_all_select_const",
};
const ADMIN_MENU_SETTINGS_URLS = {
  GET_ALL: "/admin_menu/get_all",
  INSERT: "/admin_menu/insert",
  GET_ALL_SELECT: "/admin_menu/get_all_select",
  GET_ONE: "/admin_menu/get_one",
  DELETE: "/admin_menu/delete_one",
  UPDATE: "/admin_menu/update",
  ROLE_GET_ALL_SELECT: "/role/get_all_select",
  ROLE_GET_ALL_SELECT_LABEL: "/role/get_all_select_label",
  MODULE_GET_ALL_SELECT:"/admin_modules/get_all_select",

};
export {
  ROLE_URLS,
  USER_URLS,
  STATE_URLS,
  PASS_URL,
  MODULES_URLS,
  EMAIL_SETTINGS_URLS,
  SETTINGS_URL, ADMIN_MENU_SETTINGS_URLS
};
